export default __webpack_public_path__ + "static/media/1303.d4916331.png";